module.exports = __webpack_public_path__ + "img/ADA.e255ffd8.svg";